import React from "react";
import { getDocumentLearningStatsFromRow } from "./qmsDocumentLibraryLearningUtils";
import { formatReviewDateCell } from "./qmsReviewDateUtils";

function QmsDocumentLibraryProgressCell({ row, onOpenProgress }) {
  const stats = getDocumentLearningStatsFromRow(row);
  const review = formatReviewDateCell(row);
  const hasAssignments = stats.total > 0;

  if (!hasAssignments && !review.badge) {
    return <span className="text-muted">—</span>;
  }

  return (
    <button
      type="button"
      className="qms-doc-lib__progress-cell"
      onClick={() => onOpenProgress?.(row)}
      title="View learning progress and send reminders"
    >
      {hasAssignments ? (
        <div className="qms-doc-lib__progress-main">
          <div
            className="qms-doc-lib__progress-bar"
            style={{ "--qms-progress-pct": `${stats.completionPct}%` }}
          >
            <span className="qms-doc-lib__progress-fill" />
          </div>
          <span className="qms-doc-lib__progress-ratio">
            {stats.completedCount}/{stats.total} done
          </span>
        </div>
      ) : null}
      {review.badge ? (
        <span
          className={`qms-doc-lib__review-status is-${review.status || "none"}`}
        >
          {review.badge}
        </span>
      ) : null}
    </button>
  );
}

export default QmsDocumentLibraryProgressCell;
